import { Component, OnInit } from '@angular/core';
import { DataService } from '../../service/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  public checkoutProduct: any = [];
  public total: number = 0; // Inicializar a 0 para asegurar tipo
  public envio: number = 285;
  public granTotal: number = 0;
  public productCount: number = 0;

  constructor(private data: DataService,
              private router: Router) { }

  ngOnInit(): void {
    // Suscríbete al Observable del carrito para reaccionar a los cambios
    this.data.getProductsCount().subscribe((cartItems: any[]) => {
      this.checkoutProduct = cartItems || [];
      this.updateCartSummary(); // Llama a una función para actualizar todo el resumen del carrito
    });
  }

  // --- Métodos de Actualización del Carrito ---

  // Centraliza la lógica de actualización del total, conteo y gran total
  updateCartSummary(): void {
    this.total = this.checkoutProduct.reduce((acc: number, item: any) => {
      // Asegúrate de que item.selectedSize y item.quantity existan y sean números
      const price = item.selectedSize?.price || 0;
      const quantity = item.quantity || 0;
      return acc + (price * quantity);
    }, 0);

    this.productCount = this.checkoutProduct.reduce((acc: number, item: any) => {
      // Asegúrate de que item.quantity exista y sea un número
      return acc + (item.quantity || 0);
    }, 0);

    this.calculateGrandTotal(); // Recalcula el gran total y lo guarda en sessionStorage
  }

  increaseQuantity(item: any): void {
    // Asegúrate de que item.selectedSize y item.selectedSize.stock existan
    if (item.selectedSize?.stock !== undefined && item.quantity < item.selectedSize.stock) {
      item.quantity++;
      this.data.updateCartItem(item); // El servicio notificará al BehaviorSubject
    }
  }

  decreaseQuantity(item: any): void {
    if (item.quantity > 1) {
      item.quantity--;
      this.data.updateCartItem(item); // El servicio notificará al BehaviorSubject
    }
  }

  onQuantityChange(item: any, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let quantity = parseInt(inputElement.value);

    if (isNaN(quantity) || quantity < 1) {
      quantity = 1;
    } else if (item.selectedSize?.stock !== undefined && quantity > item.selectedSize.stock) {
      quantity = item.selectedSize.stock;
    }

    item.quantity = quantity;
    this.data.updateCartItem(item); // El servicio notificará al BehaviorSubject
  }

  removeItem(productId: string): void {
    this.data.removeItemFromCheckOut(productId); // El servicio notificará al BehaviorSubject
  }

  // --- Métodos de Cálculo y Navegación ---

  calculateTotal(item: any): number {
    const price = item.selectedSize?.price || 0;
    const quantity = item.quantity || 0;
    return price * quantity;
  }

  calculateGrandTotal(): void {
    if (this.total >= 2999) {
      this.envio = 0;
    } else {
      this.envio = 285;
    }
    this.granTotal = this.total + this.envio;

    // Guarda los totales en sessionStorage
    localStorage.setItem('granTotal', JSON.stringify(this.granTotal));
    localStorage.setItem('subtotal', JSON.stringify(this.total));
    localStorage.setItem('envio', JSON.stringify(this.envio));
  }

  goToProductDetails(product: any): void {
    localStorage.setItem('selectedProduct', JSON.stringify(product));
    this.router.navigate(['/product/', product.id]);
  }

  // Método para vaciar todo el carrito (si quieres un botón para esto)
  clearAllProducts(): void {
    this.data.clearCart();
  }
}